import {TimesheetFormulaVI} from "./timesheet-formula/vi";
import {shiftVI} from "./shift/vi";
import {LeaveSettingVI} from "./annual-leave/vi";
import {timekeepingSettingVI} from "./timekeeping-setting/vi";
import {holidayVI} from "./holiday/vi";

export const TimekeepingSettingVI = {
    ...TimesheetFormulaVI,
    ...shiftVI,
    ...LeaveSettingVI,
    ...timekeepingSettingVI,
    ...holidayVI
}
